export const getBroswerLangs = (): string[] => navigator.languages.map((lang) => lang);
export const getBrowserLang = (): string => (getBroswerLangs() ? getBroswerLangs()[0] : "en-US");
